import ConversationsPage from "pages/conversation";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const getIsLoggedInUser = ({ authData }) => authData.isLoggedInUser;

function RenderAppRoutes() {
  const isLoggedInUser = useSelector(getIsLoggedInUser);

  if (!!isLoggedInUser) {
    return <ConversationsPage />;
  } else {
    return <Navigate to={"/login"} />;
  }
}

export default RenderAppRoutes;
